import { atom } from "recoil"

export const migrationAccountState = atom({
  key: "atoms/migration/migrationAccountState",
  default: 0,
})
